import { PHASES_LIST } from "@/assets/constants/selectsLists";
import SecondaryButton from "@/components/buttons/secondary-button/SecondaryButton";
import { Icon } from "@/components/icons/Icon";
import { Pill } from "@/components/pill/Pill";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import { cn } from "@/lib/styles.utils";
import { useMemo, type FC } from "react";

interface AnswerModalHeaderProps {
  title: string;
  fase: string;
  closed?: boolean;
  close?: VoidFunction;
  edition: boolean;
  setEdition?: (val: boolean) => void;
}

const AnswerModalHeader: FC<AnswerModalHeaderProps> = ({
  title,
  fase,
  closed,
  close,
  edition,
  setEdition,
}) => {
  const translate = useTranslate();

  const phase = useMemo(() => {
    return (
      PHASES_LIST.find((it) => it.id.toString() === fase.toString()) || {
        id: 0,
        name: "",
      }
    );
  }, [fase]);

  const handleOnClose = () => {
    close?.();
    setEdition?.(false);
  };

  const handleOnEdit = () => {
    setEdition?.(true);
  };

  return (
    <div>
      {!closed && !edition && (
        <div className="w-full flex justify-between items-center">
          <button
            type="button"
            onClick={handleOnClose}
            className="flex items-center space-x-2 text-ib-red-main hover:underline pb-3"
          >
            <Icon name="chevronLeft" className="size-4" />
            <span className="text-base">{translate("goBack")}</span>
          </button>
          <div className="flex">
            <SecondaryButton
              label={translate("edit")}
              onClick={handleOnEdit}
              colour="red"
              icon="pencil"
              size="small"
            />
          </div>
        </div>
      )}
      <div>
        {closed && (
          <button
            type="button"
            onClick={handleOnClose}
            className="flex items-center space-x-2 text-ib-red-main hover:underline pb-3"
          >
            <Icon name="chevronLeft" className="size-4" />
            <span className="text-base">{translate("goBack")}</span>
          </button>
        )}
        <div className={cn("flex justify-between")}>
          <div className=" flex-1 flex items-center space-x-4">
            <h3 className="text-3xl">{title}</h3>
            <Pill
              icon={closed ? "lockClose" : "refresh"}
              label={translate(phase.name)}
              className={cn(closed ? "bg-ib-gray-lightest" : "bg-ib-blue")}
              iconClassName=""
            />
          </div>
          {edition && (
            <div>
              <button type="button" onClick={handleOnClose}>
                <Icon name="close" className="size-6 text-ib-red-main" />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnswerModalHeader;
